import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import courses from './courseReducer';
import authors from './authorReducer';
import users from './userReducer';
import tasks from './taskReducer';
import currentDate from './currentDateReducer';
import taskTypes from './taskTypesReducer';
import myProjects from './myProjectsReducer';
import projectStates from './projectStatesReducer';
import roles from './roleReducer';
import timeSheets from '../container/TimeSheetContainer/reducers';
import projectContainer from '../container/ProjectContainer/reducers';
import me from './authReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';
import { reducer as reduxFormReducer } from 'redux-form';


const rootReducer = combineReducers({
    routing: routerReducer,
    form: reduxFormReducer,
    users,
    tasks,
    taskTypes,
    myProjects,
    authors,
    courses,
    timeSheets,
    projectContainer,
    me,
    ajaxCallsInProgress,
    currentDate,
    projectStates,
    roles
});

export default rootReducer;


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/